import { useEffect, useRef, useState } from "react";
import { getCustomisationValue, getGroupData } from "../../EditablePreview";
import InlineProgressBar, { convertCustomisationDataToBarSettings } from "../progress-bar/inline-progress-bar";
import VisualisedNode, { IMAGE_MODES } from "../VisualisedNode";
import './F2u.scss';
import { PROGRESS_BAR_STATE } from "../generic-progress-bar/PositionableProgressBar";

const F2uReward = (props) => {
    // console.log("F2uReward props:", props);
    const node = props.node;

    const [tick, setTick] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setTick((prevTick) => prevTick + 1);
        }, 100);
        return () => clearInterval(interval);
    }, []);

    let rewardNode = node.subNodes[1];
    let dataIndex = 0;
    if (props.visualisedNode !== props.node) {
        dataIndex = -1;
        const rewardNodeCustomisationVarsArray = getGroupData(props.node.customisationVars, rewardNode.config.groupSettings.dataLink, -1);
        const currentBarPerc = PROGRESS_BAR_STATE.perc * 100;
        // Iterate through the array until we find one where completePerc <= currentBarPerc
        // console.log("F2uReward rewardNodeCustomisationVarsArray:", rewardNodeCustomisationVarsArray, currentBarPerc);
        for (let i = 0; i < rewardNodeCustomisationVarsArray.length; i++) {
            const rewardData = rewardNodeCustomisationVarsArray[i];
            // console.log("F2uReward rewardData:", rewardData);
            if ((rewardData?.completePerc >= currentBarPerc - 1 && rewardData?.completePerc <= currentBarPerc + 1) || (rewardData?.completePerc === 100 && currentBarPerc >= 100)) {
                dataIndex = i;
            }
        }
    } else
    if (props.activeNode?.parent === rewardNode) {
        dataIndex = props.activeNode.dataIndex ?? 0;
    }

    const [rewardImgDimensions, setRewardImgDimensions] = useState({width: '100px', height: '100px'});

    if (dataIndex === -1) {
        return null;
    }

    const rewardNodeCustomisationVars = getGroupData(props.node.customisationVars, rewardNode.config.groupSettings.dataLink, dataIndex);
    // console.log("F2uReward rewardNodeCustomisationVars:", rewardNodeCustomisationVars);
    const rewardImgLoaded = (e) => {
        const img = e.target;
        setRewardImgDimensions({
            width: `${img.naturalWidth * props.previewScale}px`,
            height: `${img.naturalHeight * props.previewScale}px`
        });
    }
    // console.log(rewardNode, props.activeNode, rewardNode.subNodes.indexOf(props.activeNode), dataIndex);

    let textSettingsNode = node.subNodes[0];
    const textSettingCustomisationVars = getGroupData(props.node.customisationVars, textSettingsNode.config.groupSettings.dataLink, 0);
    // console.log("F2uReward textSettingCustomisationVars:", textSettingCustomisationVars);
    const textSettingsStyle = {margin: 0, padding: 0, whiteSpace: 'nowrap', textAlign: 'center'};
    //Does the font have a shadow
    if(textSettingCustomisationVars.showShadow)
    {
        textSettingsStyle.textShadow = textSettingCustomisationVars.shadowThickness+'px '+ textSettingCustomisationVars.shadowThickness+'px '+ textSettingCustomisationVars.shadowBlur+'px '+ textSettingCustomisationVars.shadowColour
    }
    if(textSettingCustomisationVars.addOutline)
    {
        textSettingsStyle['-webkit-text-stroke'] = textSettingCustomisationVars.outlineThickness+'px '+textSettingCustomisationVars.outlineColour;
    }

    const rewardText = getCustomisationValue(rewardNode.customisationVars, rewardNode.config.children[0].fields[0].customFieldConfig.dataLink, dataIndex, null) || "Reward";

    return (
        <div style={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>
            <div style={{width: '100%', flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <VisualisedNode {...props} node={rewardNode} imageMode={IMAGE_MODES.naturalSize}>
                    {rewardNodeCustomisationVars.showGoalImage &&
                        <div style={{minWidth: 'fit-content', width: '100%', flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <img src={rewardNodeCustomisationVars.goalImageFilename.srcUrl} alt="F2U Reward" style={{width: rewardImgDimensions.width, height: rewardImgDimensions.height}} onLoad={rewardImgLoaded} />
                        </div>
                    }
                    {rewardNodeCustomisationVars.showGoalTitle &&
                        <div style={{minWidth: 'fit-content', width: '100%', flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <VisualisedNode {...props} node={textSettingsNode}>
                                <p style={textSettingsStyle}>{rewardText}</p>
                            </VisualisedNode>
                        </div>
                    }
                </VisualisedNode>
            </div>
            
        </div>
    );
}

export default F2uReward;
